module.exports = __webpack_public_path__ + "img/Html.9918deb8.png";